import { createContext, useCallback, useContext, useState, type ReactNode } from "react";
import PartnerModal from "@/components/PartnerModal";

interface Ctx {
  open: () => void;
  close: () => void;
}

const PartnerCtx = createContext<Ctx | null>(null);

export function PartnerModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return (
    <PartnerCtx.Provider value={{ open, close }}>
      {children}
      <PartnerModal open={isOpen} onClose={close} />
    </PartnerCtx.Provider>
  );
}

export function usePartnerModal() {
  const ctx = useContext(PartnerCtx);
  if (!ctx) throw new Error("usePartnerModal must be used within PartnerModalProvider");
  return ctx;
}
